import PropTypes from 'prop-types';

export const ProductDefaultProps = {
  brand: '',
  className: '',
  code: '',
  customerPrice: 0,
  details: [],
  discountPrice: 0,
  image: {},
  invoiceUnit: '',
  manufacturerSku: '',
  name: '',
  publicPrice: 0,
  range: '',
  saleUnit: '',
  salesPackaging: 0,
  taxRate: 0,
  weeeAmount: 0,
};

export const ProductPropTypes = {
  brand: PropTypes.shape({ name: PropTypes.string }),
  className: PropTypes.string,
  code: PropTypes.string,
  customerPrice: PropTypes.number,
  details: PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.shape({
        code: PropTypes.string,
        displayable: PropTypes.bool,
        label: PropTypes.string,
        unit: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  discountPrice: PropTypes.number,
  image: PropTypes.shape({ alt: PropTypes.string, url: PropTypes.string }),
  invoiceUnit: PropTypes.string,
  manufacturerSku: PropTypes.string,
  name: PropTypes.string,
  publicPrice: PropTypes.number,
  range: PropTypes.string,
  saleUnit: PropTypes.string,
  salesPackaging: PropTypes.number,
  taxRate: PropTypes.number,
  weeeAmount: PropTypes.number,
};
